import { render } from "./Consumptions.vue?vue&type=template&id=0be478b2"
import script from "./Consumptions.vue?vue&type=script&lang=js"
export * from "./Consumptions.vue?vue&type=script&lang=js"
script.render = render

export default script